define('extensions/knockout.multiSubscribe',[
    'lib/knockout',
    'lib/lodash4'
], function(
    ko,
    _
) {
    "use strict";

    ko.multiSubscribe = function (targets, callback /*,callbackTarget, event*/) {
        if(!_.isArray(targets) || !_.every(targets, ko.isObservable)) {
            throw new Error("multiSubscribe expect an array of observables (or computeds) as its first argument");
        }

        var callbackFromTargets = function () {
            var currentValues = _.map(targets, function (target) {
                return target();
            });
            callback.apply(this, currentValues);
        };

        var subscribeArguments = [callbackFromTargets].concat([].slice.call(arguments, 2));

        var subscriptions = _.map(targets, function(target) {
            return target.subscribe.apply(target, subscribeArguments);
        });

        return {
            dispose: function () {
                _.invokeMap(subscriptions, "dispose");
            }
        };
    };
});
